import React from "react";
import { Button, Flex, GridItem } from "@chakra-ui/react";
import { BiEditAlt } from "react-icons/bi";
import { Grid, InputView } from "components";
import { types } from "../../duck";

interface ViewProps {
  initialValues: types.Organization;
  onEdit: () => void;
}

const View: React.FC<ViewProps> = ({ initialValues, onEdit }) => {
  return (
    <>
      <Flex>
        <Grid flex={1}>
          <GridItem>
            <InputView label="Name" value={initialValues.name} />
          </GridItem>
          <GridItem>
            <InputView label="Description" value={initialValues?.description} />
          </GridItem>
          <GridItem>
            <InputView
              label="Contact Email"
              value={initialValues?.contactEmail}
            />
          </GridItem>
          <GridItem colStart={1}>
            <InputView
              label="Logo"
              value={initialValues?.logo}
              type="image"
              imageProps={{ objectFit: "contain" }}
            />
          </GridItem>
        </Grid>
        <Button colorScheme="minor" leftIcon={<BiEditAlt />} onClick={onEdit}>
          Edit
        </Button>
      </Flex>
    </>
  );
};

export default View;
